import {Component, Input} from '@angular/core';
import {NgIf, NgFor} from '@angular/common';
import {MatDividerModule} from '@angular/material/divider';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {TranslateModule} from '@ngx-translate/core';
import {ConfigService} from '@q9elements/ui-kit/common';
import {UserInfoComponent} from '@q9elements/ui-kit/components';
import {AuthorisationTaskStatusPipe} from '../pipes/authorisation-task-status.pipe';
import {InterpolatePipe} from '../../../diagram-render/helpers/interpolate.pipe';

@Component({
  selector: 'app-authorisation-popup',
  templateUrl: './authorisation-popup.component.html',
  styleUrls: ['./authorisation-popup.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatDividerModule,
    UserInfoComponent,
    NgFor,
    MatProgressSpinnerModule,
    InterpolatePipe,
    AuthorisationTaskStatusPipe,
    TranslateModule
  ]
})
export class AuthorisationPopupComponent {
  @Input() showCurrentTask = true;
  @Input() config;
  @Input() userHistory;

  public TASK_LIST_URL = `${ConfigService.environment.MAIN_APP_URL}/tasks?ref=active&list=assigned-to-me`;
  anchorTarget: string = window.top !== window.self ? '_self' : '_blank';
}
